import { AgentOptions } from '@newrelic/browser-agent/loaders/agent';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { env } from './helper.utils';

const newRelicLoaderConfig: AgentOptions['loader_config'] = {
  accountID: env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
  trustKey: env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
  agentID: env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  licenseKey: env.REACT_APP_NEW_RELIC_LICENSE_KEY,
  applicationID: env.REACT_APP_NEW_RELIC_APPLICATION_ID
};

const newRelicInfo: AgentOptions['info'] = {
  beacon: 'bam.eu01.nr-data.net',
  errorBeacon: 'bam.eu01.nr-data.net',
  licenseKey: env.REACT_APP_NEW_RELIC_LICENSE_KEY,
  applicationID: env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  sa: 1
};

const newRelicInit: AgentOptions['init'] = {
  logging: { enabled: true },
  session_replay: {
    enabled: true,
    block_selector: '',
    mask_text_selector: '',
    sampling_rate: 0.01,
    error_sampling_rate: 100.0,
    mask_all_inputs: false,
    collect_fonts: true,
    inline_images: false,
    fix_stylesheets: true,
    mask_input_options: {
      color: true,
      date: true,
      datetime_local: true,
      month: true,
      number: true,
      range: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true,
      select: true,
      textarea: true
    }
  },
  distributed_tracing: { enabled: true },
  privacy: { cookies_enabled: true },
  ajax: { deny_list: ['bam.eu01.nr-data.net'] }
};

const newRelicConfig: AgentOptions = {
  loader_config: newRelicLoaderConfig,
  info: newRelicInfo,
  init: newRelicInit
};

export const newrelic = new BrowserAgent(newRelicConfig);
